export const data = [
  {
    id: 1,
    img: "assets/mike.jpg",
    name: "Michael Nzegwu",
    designation: "C.E.O Metrovatech",
    desc: "We have worked on many different projects. Prosper is always focused on delivering the job on time",
  },
  {
    id: 2,
    img: "assets/dr-charles.jpg",
    name: "Dr. Charles Chukwu",
    designation: "C.E.O WeildMasters Ltd.",
    desc: "I love people that keep to their words. Prosper is one of them. And I am satisfied with what I got",
  },
  {
    id: 3,
    img: "assets/abiye.jpg",
    name: "Abiye Samuel Lasbry",
    designation: "C.E.O Punters Companion",
    desc: "He didn't just build the website, he also gave technical advice and support. nice guy",
  },
];
